import React from 'react';
import './preview-border.styles.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOut } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { setCurrentUser } from '@/state/slices/userSlice';
import { useNavigate } from 'react-router-dom';

const PreviewBorder = () => {
  
  const dispatch = useDispatch();
  const navigate = useNavigate();

  async function exitPreview() {
    navigate('/logout/?redirectUrl=/preview');
  }

  return (
    <div className='preview-border'>
        <div className='buttons'>
            <button className='g-button small-btn' onClick={exitPreview}>
                <FontAwesomeIcon icon={faSignOut} />
                Exit Preview
            </button>
        </div>
    </div>
  )
}

export default PreviewBorder